import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';

import InputAdornment from '@mui/material/InputAdornment';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import IconButton from '@mui/material/IconButton';

import { Tabs, Tab, CircularProgress } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';

import J2VAuth from "../../libs/auth.js";

import { createClient } from 'pexels';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function VESource(props) {

    const { element } = props;
    const [openSourceDialog, setOpenSourceDialog] = React.useState(false);
    const [openScaleDialog, setOpenScaleDialog] = React.useState(false);
    const [returnedMedia, setReturnedMedia] = React.useState(null);

    // switch(element.type) {
    //     case "video": <video src={element.src || ""} style={{ maxWidth: "200px", maxHeight: "250px" }} controls className="rounded-lg cursor-pointer" alt="thumbnail" />
    //     case "image": <img onClick={handleOpenDialog} src={element.src || ""} style={{ maxWidth: "200px", maxHeight: "250px" }} className="rounded-lg cursor-pointer" alt="thumbnail" />
    //     case "audio":
    //     case "default": 
    // }

    return (
        <>
            <TextField 
                onClick={handleOpenDialog} 
                value={element.src || ""} 
                fullWidth={true} disabled 
                sx={props.sx}
                variant="outlined"
                size="small"
                label={props.label}
                InputProps={{
                    ...props.InputProps,
                    endAdornment: (
                        <InputAdornment position="end" className="cursor-pointer" >
                            <EditIcon />
                        </InputAdornment>
                    )
                }}
            />
            {
                openSourceDialog && <VESourceDialog open={openSourceDialog} onClose={handleCloseSourceDialog} {...props} />
            }
            {
                openScaleDialog && <VEScaleDialog open={openScaleDialog} onClose={handleCloseScaleDialog} element={element} />
            }
        </>
    );

    function handleOpenDialog() {
        setOpenSourceDialog(true);
    }

    function handleCloseSourceDialog(media = null) {
        setOpenSourceDialog(false);
        console.log("onClose", media);

        if (["video", "image"].includes(element.type) && media && (media.width !== props.movieWidth || media.height !== props.movieHeight)) {
            // if it's video or image, and the media size is different than the movie size
            // offer to scale the media to contain or cover the movie

            setReturnedMedia(media);
            setOpenScaleDialog(true);
        }
        else {
            // else, update the element
            props.updateProperty(media);
        }
    }

    function handleCloseScaleDialog(action = "none") {
        setOpenScaleDialog(false);

        if (action === "fit") {
            const ratio = Math.min(props.movieWidth / returnedMedia.width, props.movieHeight / returnedMedia.height);
            returnedMedia.scale = {
                width: parseInt(returnedMedia.width * ratio),
                height: parseInt(returnedMedia.height * ratio)
            };
        }
        else if (action === "cover") {
            const ratio = Math.max(props.movieWidth / returnedMedia.width, props.movieHeight / returnedMedia.height);
            returnedMedia.scale = {
                width: parseInt(returnedMedia.width * ratio),
                height: parseInt(returnedMedia.height * ratio)
            };
        }

        props.updateProperty(returnedMedia);
        setReturnedMedia(null);
    }
}


function VESourceDialog(props) {

    const { element, field } = props;

    const [activeTab, setActiveTab] = React.useState("url");


    const [urlFieldValue, setURLFieldValue] = React.useState(element.src ?? "");
    const [urlSearch, setURLSearch] = React.useState(urlFieldValue);
    const [urlInfo, setURLInfo] = React.useState({});
    const [urlElementLoaded, setURLElementLoaded] = React.useState(false);

    const [queryFieldValue, setQueryFieldValue] = React.useState("");
    // const [querySearch, setQuerySearch] = React.useState("");
    const [searchResults, setSearchResults] = React.useState([]);
    const [loadingSearchResults, setLoadingSearchResults] = React.useState(false);
    const [selectedResult, setSelectedResult] = React.useState(null);
    const resultsPerPage = 10;
    const [page, setPage] = React.useState(0);

    const [readyToSave, setReadyToSave] = React.useState(true);

    const [uploadingFile, setUploadingFile] = React.useState(false);

    const [alertDialogMessage, setAlertDialogMessage] = React.useState(null);

    React.useEffect(() => {
        submitURLSearch();
    }, []);

    // React.useEffect(() => { searchMedia(); }, [querySearch]);
    React.useEffect(() => {
        if (activeTab !== "url" && selectedResult !== null) setReadyToSave(true); else setReadyToSave(false);
    }, [selectedResult]);

    let itemDescription = "";
    switch (element.type) {
        case "image": itemDescription = "an image"; break;
        case "video": itemDescription = "a video"; break;
        case "audio": itemDescription = "an audio"; break;
        default: itemDescription = "a " + element.type; break;
    }

    return (
        <>
            <Dialog open={props.open} fullWidth={true} maxWidth="md" onClose={handleCancelDialog} scroll="paper">
                <DialogTitle><span className="font-bold">Choose {itemDescription}</span></DialogTitle>
                <DialogContent sx={{ paddingBottom: "0" }} dividers={true}>
                    {showTabs()}
                    {
                        (activeTab === "url") ? urlSearchTab() : thirdPartyTab(activeTab)
                    }
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancelDialog}>Cancel</Button>
                    <Button onClick={handleSaveDialog} variant="contained" disabled={!readyToSave} >Save</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={alertDialogMessage !== null}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAlertDialogMessage(null)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{(alertDialogMessage) ? alertDialogMessage.split("|")[0] : ""}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {(alertDialogMessage) ? alertDialogMessage.split("|")[1] : ""}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAlertDialogMessage(null)}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );

    function getRandomTopic() {
        const topics = ["surf", "bike", "music", "train"];
        return topics[Math.floor(Math.random() * topics.length)];
    }

    function handleCancelDialog() {
        props.onClose();
    }

    function handleSaveDialog() {
        if (activeTab === "url") {
            console.log("Saving URL", urlInfo);
            props.onClose(urlInfo);
        }
        else {
            props.onClose(searchResults[selectedResult]);
        }
    }

    function showTabs() {
        return (
            <Tabs value={activeTab} onChange={onTabChange}>
                <Tab value="url" label="URL" />
                <Tab value="uploads" label="Uploads" />
                {
                    (element.type === "video" || element.type === "image") && (
                        <Tab value="pexels" label="Pexels" />        
                    )
                }
                {
                    (element.type === "image") && (
                        <Tab value="unsplash" label="Unsplash" />
                    )
                }
            </Tabs>
        );
    }

    function onTabChange(event, newValue) {
        setActiveTab(newValue);

        console.log("onTabChange", newValue);

        if (newValue === "url") {
            submitURLSearch();
        }
        else {
            // setQuerySearch("");
            setQueryFieldValue("");

            setSelectedResult(null);
            setReadyToSave(false);
            searchMedia(newValue, "", 0);
        }
    }

    function urlSearchTab() {
        return (
            <>
                <Box className="mt-9 flex items-end">
                    <TextField
                        fullWidth={true} label="Type a URL"
                        type="text" value={urlFieldValue}
                        onKeyDown={(event) => { if (event.keyCode === 13) submitURLSearch(); }}
                        onChange={(event) => { setURLFieldValue(event.target.value); setReadyToSave(false); }} />
                    <Button variant="outlined" size="small" sx={{ marginLeft: "0.5rem" }} onClick={submitURLSearch}>ENTER <KeyboardReturnIcon /></Button>
                </Box>
                <Box>
                    <Stack direction="row" className="mt-2 max-h-96 overflow-hidden">
                        {urlPreviewPanel()}
                        {urlDetailPanel()}
                    </Stack>
                </Box>
            </>
        );
    }

    function submitURLSearch() {
        setURLSearch(urlFieldValue);
        setReadyToSave(true);
        getURLInfo(urlFieldValue);
    }

    function urlPreviewPanel() {

        const previewSize = { width: "550px", height: "300px" };

        if (["video", "audio"].includes(element.type)) {
            return (
                <Box className="my-6">
                    {
                        (urlElementLoaded) ? (
                            (element.type === "video") ? (
                                <video
                                    src={urlSearch}
                                    style={previewSize}
                                    className="border-4 border-white rounded-lg cursor-pointer"
                                    controls={true}
                                ></video>    
                            ) :
                            (
                                <audio
                                    src={urlSearch}
                                    style={previewSize}
                                    className="border-4 border-white rounded-lg cursor-pointer"
                                    controls={true}
                                ></audio>
                            )
                            
                        ) : (
                            <div style={previewSize} className="bg-gray-100 border border-gray-300 rounded-lg flex items-center justify-center">
                                <CircularProgress />
                            </div>
                        )
                    }
                </Box>
            );
        }
        else return (
            <Box className="my-6 w-2/3 shrink-0">
                <object
                    data={urlSearch} alt=""
                    style={{ maxWidth: "450px", maxHeight: "250px" }}
                    className="border-4 border-white rounded-lg cursor-pointer">
                    <div className="bg-gray-100 border border-gray-300 rounded-lg flex items-center justify-center" style={{ width: "440px", height: "240px" }} >
                        Image not found
                    </div>
                </object>
            </Box>
        );
    }

    function urlDetailPanel() {
        if (!urlInfo) return null;

        return (
            <Box className="my-6 w-1/3 ml-5 border-l border-gray-300 pl-5">
                <p className="font-bold text-lg">{urlInfo.alt}</p>
                <p><span className="font-bold text-sm">width</span>: {urlInfo.width ?? "n/a"} px</p>
                <p><span className="font-bold text-sm">height</span>: {urlInfo.height ?? "n/a"} px</p>
                {
                    (urlInfo.duration) &&
                    <p><span className="font-bold text-sm">duration</span>: {parseInt(urlInfo.duration)} seconds</p>
                }
            </Box>
        );
    }

    async function getURLInfo(url) {
        setURLElementLoaded(false);
        setURLInfo({});

        console.log("getURLInfo()", url);

        if (element.type === "image") {
            let elementNode;
            elementNode = new Image();
            elementNode.onload = function () {
                const lastSlash = url.lastIndexOf("/"), firstQuestionMark = url.indexOf("?", lastSlash);
                const title = (firstQuestionMark !== -1) ? url.substring(lastSlash + 1, firstQuestionMark) : url.substring(lastSlash + 1);

                setURLInfo({
                    type: "image",
                    url: url,
                    width: this.naturalWidth,
                    height: this.naturalHeight,
                    thumbnail: url,
                    alt: title,
                });
                setURLElementLoaded(true);
            };
            elementNode.onerror = function () {
                // console.log("onerror", url);
                setURLElementLoaded(true);
                setURLInfo({
                    type: "image",
                    url: url
                });
            }
            elementNode.setAttribute("src", url);
        }
        else if (["video", "audio"].includes(element.type)) {
            let elementNode;
            elementNode = document.createElement("video");
            elementNode.onloadeddata = function () {
                const lastSlash = url.lastIndexOf("/"), firstQuestionMark = url.indexOf("?", lastSlash);
                const title = (firstQuestionMark !== -1) ? url.substring(lastSlash + 1, firstQuestionMark) : url.substring(lastSlash + 1);

                setURLInfo({
                    type: element.type,
                    url: url,
                    width: this.videoWidth,
                    height: this.videoHeight,
                    thumbnail: url,
                    alt: title,
                    duration: this.duration,
                });

                setURLElementLoaded(true);
            }
            elementNode.onerror = function () {
                // console.log("onerror", url);
                setURLElementLoaded(true);
                setURLInfo({
                    type: element.type,
                    url: url
                });
            }
            elementNode.setAttribute("src", url);
        }
    }

    function thirdPartyTab(partner) {
        return (
            <>
                <Box className="mt-9 flex items-end">
                    <TextField
                        className="grow" label="Search library"
                        type="text" value={queryFieldValue}
                        onKeyDown={(event) => { if (event.keyCode === 13) submitQuerySearch(event.target.value); }}
                        onChange={(event) => { setQueryFieldValue(event.target.value);  }} />
                    <Button variant="outlined" size="small" sx={{ marginLeft: "0.5rem" }} onClick={submitURLSearch}>ENTER <KeyboardReturnIcon /></Button>
                    {
                        (partner === "uploads") && (
                            <form>
                                <label htmlFor="filePicker">
                                    {
                                        (uploadingFile) ?
                                            <div className="ml-5 h-8 bg-gray-200 text-gray-400 px-3 rounded-md flex items-center cursor-wait">
                                                UPLOADING... <CircularProgress size="1rem" className="ml-3" />
                                            </div>
                                            :
                                            <div className="ml-5 h-8 bg-blue-500 text-white px-3 rounded-md flex items-center cursor-pointer">UPLOAD FILE</div>
                                    }
                                </label>
                                <input 
                                    id="filePicker" 
                                    style={{ display: "none" }} 
                                    type={"file"}
                                    accept={element.type + "/*"}
                                    onChange={submitUploadForm}></input>
                            </form>
                        )
                    }
                </Box>
                <Box>
                    <Stack direction="row" className="mt-2 h-96 overflow-hidden">
                        {queryPreviewPanel()}
                        {queryDetailPanel()}
                    </Stack>
                </Box>
            </>
        );
    }

    async function submitQuerySearch(query) {
        setSearchResults([]);
        console.log("submitQuerySearch", query);
        searchMedia(null, query);
        // setQuerySearch(queryFieldValue);
    }

    function queryPreviewPanel() {
        return (
            <Box className="my-6 w-2/3 shrink-0 overflow-y-scroll">
                <Box className="flex flex-wrap">
                    {
                        // List results
                        searchResults.map((result, index) => {
                            let cssClasses = "border-4 border-gray-100 rounded-lg cursor-pointer";
                            if (selectedResult === index) cssClasses = "border-4 border-blue-400 rounded-lg cursor-pointer";

                            let resultDescription = (result.alt) ? (result.alt.substring(0, 30) + ((result.alt.length > 30) ? "..." : "")) : "n/a";

                            if (result.type === "video") {
                                return (
                                    <Box key={index} className="w-1/2 mt-5 flex flex-col items-center">
                                        <video
                                            id={index} key={index}
                                            onClick={(event) => { setSelectedResult(parseInt(event.target.id)) }}
                                            onMouseOver={event => event.target.play()}
                                            onMouseOut={event => event.target.pause()}
                                            src={result.url}
                                            className={cssClasses}
                                            style={{ maxWidth: "265px", maxHeight: "320px" }} />
                                        <p className="mt-1 text-sm text-center">video: {resultDescription}</p>
                                    </Box>
                                );
                            }
                            else return (
                                <Box key={index} className="w-1/2 mt-5 flex flex-col items-center">
                                    <img
                                        onClick={(event) => { setSelectedResult(parseInt(event.target.id)) }}
                                        src={result.thumbnail} alt={result.alt} id={index} key={index}
                                        style={{ maxWidth: "265px", maxHeight: "320px" }} className={cssClasses} />
                                    <p className="mt-1 text-sm text-center">image: {resultDescription}</p>
                                </Box>
                            );
                        })
                    }
                </Box>
                {
                    // Load more button
                    (!loadingSearchResults && page < 5) &&
                    (
                        <Box className="w-full my-5 flex justify-center"><Button size="small" onClick={loadMoreResults}>Load more results</Button></Box>
                    )
                }
                {
                    // Loading spinner
                    (!searchResults.length || loadingSearchResults) &&
                    (
                        <div className="mt-5 flex justify-center">
                            <div className="flex flex-col items-center">
                                <CircularProgress />
                                <p className="mt-4">Searching ...</p>
                            </div>
                        </div>
                    )
                }
            </Box>
        );
    }

    function queryDetailPanel() {
        if (selectedResult === null || searchResults[selectedResult] === undefined) return null;

        const result = searchResults[selectedResult];

        return (
            <Box className="my-6 pl-5">
                <p className="font-bold text-lg">{result.alt ?? "Untitled"}</p>
                {
                    (result.source && result.sourceURL) &&
                    <p className="mb-3"><span className="font-bold text-sm">Author</span>: <a className="underline" target="_blank" rel="noreferrer" href={result.sourceURL}>{result.source}</a></p>
                }
                <p><span className="font-bold text-sm">width</span>: {result.width ?? "n/a"} px</p>
                <p><span className="font-bold text-sm">height</span>: {result.height ?? "n/a"} px</p>
                <p><span className="font-bold text-sm">duration</span>: {result.duration ? result.duration + " seconds" : "n/a"}</p>

            </Box>
        );
    }

    async function searchMedia(partner = null, querySearchParam = null, pageNum = 0) {
        if (!partner) partner = activeTab; // pexels, unsplash, pixabay, ...
        if (partner === "url") return;

        // if (!querySearchParam) querySearchParam = querySearch;

        console.log("searchMedia: ", partner, querySearchParam, pageNum);
        setLoadingSearchResults(true);

        switch (partner) {
            case "uploads": getUploadsMedia(querySearchParam, element.type, pageNum); break;
            case "pexels": getPexelsMedia(querySearchParam, element.type, pageNum); break;
            case "unsplash": getUnsplashMedia(querySearchParam, element.type, pageNum); break;
            default: break;
        }
    }

    function loadMoreResults() {
        if (page >= 5) {
            console.log("No more results");
            return;
        }
        const previousPage = page, newPage = previousPage + 1;
        console.log("Loading more results...", newPage);
        setPage(newPage);
        searchMedia(null, null, newPage);
    }

    async function getPexelsMedia(searchQuery, type = "image", pageNum = 0) {

        if (searchQuery === "") searchQuery = getRandomTopic();

        console.log("Loading from pexels media: ", searchQuery, type, pageNum);
        const pexelsClient = createClient('zVUri5HHGtLECNvJa0w1f6VbDQYtuotK7YJEfj8SJVwOiO2gPF2C9vWQ');

        if (type === "image") {
            pexelsClient.photos.search({ query: searchQuery, page: pageNum + 1, per_page: resultsPerPage }).then((response) => {
                let newResults = [];
                response.photos.map((photo) => {
                    newResults.push({
                        type: "image",
                        url: photo.src.original,
                        thumbnail: photo.src.medium,
                        width: photo.width,
                        height: photo.height,
                        alt: photo.alt,
                        source: photo.photographer,
                        sourceURL: photo.photographer_url,
                    });
                    return true;
                });
                if (pageNum > 0) newResults = searchResults.concat(newResults);
                setSearchResults(newResults);
                setLoadingSearchResults(false);
            });
        }
        else if (type === "video") {
            pexelsClient.videos.search({ query: searchQuery, page: pageNum + 1, per_page: resultsPerPage }).then(response => {
                let newResults = [];
                response.videos.map((video) => {
                    // console.log("video: ", video);

                    // find the best matching video resolution
                    let bestMatch = null, minDifference = Number.MAX_SAFE_INTEGER;
                    for (let vf = 0; vf < video.video_files.length; vf++) {
                        const videoFile = video.video_files[vf];
                        const widthDifference = Math.abs(videoFile.width - props.movieWidth);
                        const heightDifference = Math.abs(videoFile.height - props.movieHeight);

                        if (!bestMatch || (widthDifference + heightDifference) < minDifference) {
                            bestMatch = videoFile;
                            minDifference = widthDifference + heightDifference;
                        }
                    }

                    const videoURL = bestMatch.link;
                    newResults.push({
                        type: "video",
                        url: videoURL,
                        thumbnail: video.image,
                        width: video.width,
                        height: video.height,
                        duration: video.duration,
                        alt: `${video.width}x${video.height} - ${video.duration} seconds`,
                        source: video.user.name,
                        sourceURL: video.user.url,
                    });
                    return true;
                });
                if (pageNum > 0) newResults = searchResults.concat(newResults);
                setSearchResults(newResults);
                setLoadingSearchResults(false);
            });
        }
    }

    async function getUnsplashMedia(searchQuery, type = "image", pageNum = 0) {

        if (searchQuery === "") searchQuery = getRandomTopic();

        const unsplashUrl = `https://api.unsplash.com/search/photos/?query=${searchQuery}&page=${pageNum + 1}&per_page=${resultsPerPage}&client_id=zCG2fqb4exEUqZqsWmXdxe7PZZTwckj3o0SNHcWJR0Q`;
        console.log("Loading unsplash media: ", searchQuery, type, unsplashUrl);

        if (type === "image") {
            fetch(unsplashUrl)
                .then((response) => response.json())
                .then((response) => {
                    console.log(response);
                    let newResults = [];
                    response.results.map((photo) => {
                        newResults.push({
                            type: "image",
                            url: photo.urls.raw,
                            thumbnail: photo.urls.small,
                            width: photo.width,
                            height: photo.height,
                            alt: photo.alt_description ?? `${photo.width}x${photo.height}`,
                            source: photo.user.name,
                            sourceURL: photo.user.portfolio_url
                        });
                        return true;
                    });
                    if (pageNum > 0) newResults = searchResults.concat(newResults);
                    setSearchResults(newResults);
                    setLoadingSearchResults(false);
                })
        }
    }

    async function getUploadsMedia(searchQuery, type = "image", pageNum = 0) {

        if (!searchQuery) searchQuery = "";

        const uploadsApiUrl = `https://api.json2video.com/v2/uploads?q=${searchQuery}&page=${pageNum}&per_page=${resultsPerPage}&type=${type}`;
        console.log("Loading uploads media: ", searchQuery, type, uploadsApiUrl);

        const userCredentials = J2VAuth.getCredentials();
        if (!userCredentials) {
            console.log("No user credentials");
            return;
        }

        fetch(uploadsApiUrl, {
            method: "GET",
            headers: {
                [userCredentials.headerName]: userCredentials.headerValue
            }
        })
            .then((response) => response.json())
            .then((response) => {
                console.log(response);
                let newResults = [];
                response.files.map((file) => {
                    newResults.push({
                        type: type,
                        url: file.url,
                        thumbnail: (type==="image") ? file.url : null,
                        width: null,
                        height: null,
                        alt: file.fileName,
                        source: null,
                        sourceURL: null,
                    });
                    return true;
                });
                if (pageNum > 0) newResults = searchResults.concat(newResults);
                setSearchResults(newResults);
                setLoadingSearchResults(false);
            });
    }

    async function submitUploadForm(event) {
        event.preventDefault();

        const elementType = element.type;

        setUploadingFile(true);
        
        try {
            const userCredentials = J2VAuth.getCredentials();
            const file = event.target.files[0];
            const fileType = file.type.split("/")[0];
            
            if (fileType !== elementType) {
                console.log("Invalid file type");
                throw new Error("Invalid file type");
            }

            // Get the upload endpoint URL
            const uploadEndpoint = await fetch("https://api.json2video.com/v2/uploads", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    [userCredentials.headerName]: userCredentials.headerValue
                },
                body: JSON.stringify({
                    contentType: file.type,
                    name: file.name
                })
            }).then((response) => response.json()).catch(() => {
                console.log("Getting upload endpoint exception");
                throw new Error("Endpoint exception|There was a problem getting the upload endpoint.");
            });

            if (!uploadEndpoint || !uploadEndpoint.success) {
                console.log("Upload failed");
                throw new Error("Upload failed|There was a problem uploading the file:" + uploadEndpoint.message);
            }

            // Upload the file
            await fetch(uploadEndpoint.signedUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": file.type
                },
                body: file
            }).then((response) => {
                console.log("Fetch upload response: ", response.body);
                return response.text();
            }).then((response) => {
                console.log("Upload text response: ", response);
                return response;
            }).catch(() => {
                console.log("Upload exception");
                throw new Error("Upload failed");
            });

            // Refresh list of files
        }
        catch (error) {
            console.log("Catch upload exception", error);
            setAlertDialogMessage(error.message);
        }

        setUploadingFile(false);
        searchMedia();
    }
}

function VEScaleDialog(props) {

    const element = props.element;

    return (
        <Dialog open={props.open} fullWidth={true} maxWidth="md" onClose={() => { props.onClose() }} scroll="paper">
            <DialogTitle><span className="font-bold">Scale selected {element.type}</span></DialogTitle>
            <DialogContent dividers={true}>
                <p>The {element.type} you selected does not match the video viewport.</p>
                <p className="mt-3">Do you want to scale the selected {element.type} to fit or cover the video size?</p>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => { props.onClose() }}>No, thanks</Button>
                <Button variant="contained" onClick={() => { props.onClose("fit") }}>Scale to fit</Button>
                <Button variant="contained" onClick={() => { props.onClose("cover") }}>Scale to cover</Button>
            </DialogActions>
        </Dialog>
    );
}